import{jsx as t,Fragment as r}from"react/jsx-runtime";const e=()=>t(r,{});export{e as default};
